import React, { useEffect, useState, useMemo, useRef } from "react";
import csiJson from "./data/csi.json";
import DialogModal from "./components/DialogModal";
import { startDownload } from "./components/DownloadSwatch";
import { lightOrDark, colorMatrix } from "./utilities/Utilities";
import SettingsModal from "./components/SettingsModal";
import Menu from "./components/Menu";
import { motion } from "framer-motion";
import useWindowDimensions from "./utilities/useWindowDimensions";
import NavMenu from "./components/NavMenu";
import ReactGA from "react-ga";
import crustBase from "./data/csi_to_cc.json";

import ImageDialog from "./components/ImageDialog";

import {
  starSolidIcon,
  closeIcon,
  searchIcon,
  utilityLogoMatlib,
  menuIcon,
  checkIcon,
} from "./components/Icons";
import merge from "lodash/merge";
import uniqBy from "lodash/uniqBy";

function CsiList() {
  const data = useMemo(() => csiJson, []);
  const containerRef = useRef(null);
  const { width, height } = useWindowDimensions();

  const storedData = JSON.parse(localStorage.getItem("csi-selected"));
  const storedDelta = parseInt(localStorage.getItem("delta"));
  const storedSwatchSize = JSON.parse(localStorage.getItem("swatch-size"));

  const [csi, setCsi] = useState([]);
  const [full, setFull] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [popup, setPopup] = useState(false);
  const [settingDialog, setSettingDialog] = useState(false);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [store, setStore] = useState(storedData || []);
  const [colorAttribute, setColorAttribute] = useState([]);
  const [colorAttributeFound, setColorAttributeFound] = useState([]);
  const [colorDelta, setColorDelta] = useState(storedDelta || 20);
  const [similarColorThumb, setSimilarColorThumb] = useState(
    storedSwatchSize || "25"
  );
  const [enableToolTip, setEnableToolTip] = useState(true);
  const [openNav, setOpenNav] = useState(false);
  const [common, setCommon] = useState(false);

  const [viewStore, setViewStore] = useState(false);

  useEffect(() => {
    const filteredJson = uniqBy(data, "csi_code");
    //console.log(crustBase.map((item) => item.csi === filteredJson.csi_code));
    const csiData = filteredJson.map((item) =>
      merge(
        [{ hex: item.hex, csi_code: item.csi_code, csi_name: item.csi_name }],
        [
          {
            colorAtt: colorMatrix(item.hex),
            isDark: lightOrDark(item.hex),
            crust: hasCrustbase(item.csi_code),
          },
        ]
      )
    );
    setCsi(csiData);
  }, [data]);

  const hasCrustbase = (csi) => {
    const has = crustBase.filter((clr) => clr.csi === csi);
    const crust = has.map((item) => item.crust);
    if (crust !== undefined) {
      return crust[0];
    }
    return null;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value.toLowerCase());
    setViewStore(false);
  };

  const handleClick = (swatch, location) => {
    setSelected(swatch);
    setPopup(true);
    setColorAttribute(swatch.colorAtt);
    // ReactGA.pageview(
    //   window.location.pathname + `/main/${swatch.csi_code}-${swatch.csi_name}`
    // );
    ReactGA.event({
      category: "view",
      action: `${swatch.csi_code}-${swatch.csi_name}`,
      label: location,
    });
  };
  const handleClose = () => {
    setPopup(false);
  };

  const handleStore = (csi) => {
    if (store.includes(csi)) {
      setStore(store.filter((item) => item !== csi));
      setPopup(false);
    } else {
      ReactGA.event({
        category: "Store",
        action: `${selected.csi_code}-${selected.csi_name}`,
      });
      setStore((item) => [...item, csi]);
    }
  };

  useEffect(() => {
    const jsonData = JSON.stringify(store);
    localStorage.setItem("csi-selected", jsonData);
    if (store?.length === 0) {
      setViewStore(false);
      //setMenuOpen(false);
    }
  }, [store]);

  useEffect(() => {
    const result = csi
      .filter((item) => {
        if (!search) return true;
        if (
          item[0].csi_name.toLowerCase().includes(search) ||
          item[0].csi_code.toLowerCase().includes(search)
        ) {
          return true;
        }
        return false;
      })
      .map((item) => [
        {
          hex: item[0].hex,
          csi_code: item[0].csi_code,
          csi_name: item[0].csi_name,
          colorAtt: item[0].colorAtt,
          isDark: item[0].isDark,
          crust: hasCrustbase(item[0].csi_code),
        },
      ]);
    setFull(result);
  }, [search, csi]);

  useEffect(() => {
    const result = csi.filter(
      (item) =>
        colorAttribute[0] >= item[0].colorAtt[0] - colorDelta &&
        colorAttribute[0] <= item[0].colorAtt[0] + colorDelta &&
        colorAttribute[1] >= item[0].colorAtt[1] - colorDelta &&
        colorAttribute[1] <= item[0].colorAtt[1] + colorDelta &&
        colorAttribute[2] >= item[0].colorAtt[2] - colorDelta &&
        colorAttribute[2] <= item[0].colorAtt[2] + colorDelta
    );

    setColorAttributeFound(result);
    // eslint-disable-next-line
  }, [colorAttribute, colorDelta]);

  const SelectGroup = () => {
    if (store?.length >= 1) {
      const findStoredData = store.map((item) =>
        csi.filter((data) => data[0].csi_code === item)
      );
      const filterStoredData = findStoredData.map((item) => item[0]);
      ReactGA.pageview(window.location.pathname + `/store`);
      return filterStoredData.map((swatch, i) => (
        <div
          onClick={() => handleClick(swatch[0], "swatch")}
          key={swatch[0].csi_code + i}
          className="csi-swatch"
          style={{
            background: "#FEFEFE",
            fontSize: swatch[0].csi_name.length <= 12 ? "14px" : "13px",
            // background:
            //   colorAttribute[0] >= swatch[0].colorAtt[0] - colorDelta &&
            //   colorAttribute[0] <= swatch[0].colorAtt[0] + colorDelta &&
            //   colorAttribute[1] >= swatch[0].colorAtt[1] - colorDelta &&
            //   colorAttribute[1] <= swatch[0].colorAtt[1] + colorDelta &&
            //   colorAttribute[2] >= swatch[0].colorAtt[2] - colorDelta &&
            //   colorAttribute[2] <= swatch[0].colorAtt[2] + colorDelta
            //     ? "repeating-linear-gradient(-45deg, rgb(229 233 241), rgb(237 238 241) 10px, rgb(255 255 255) 10px, rgb(255 255 255) 20px)"
            //     : "#FEFEFE",
          }}
        >
          <div
            className="csi-thumbnail"
            style={{
              backgroundColor: swatch[0].hex,
            }}
          />
          <div
            className="csi-text-background"
            style={{ background: swatch[0].hex + "40" }}
          >
            <h3>
              {swatch[0].csi_code} - {swatch[0].csi_name}
            </h3>
          </div>
          <div
            className="csi-thumbnail-right"
            style={{
              backgroundColor: swatch[0].hex,
            }}
          >
            <span style={{ color: swatch[0].isDark ? "white" : "#3E4042" }}>
              {store.includes(swatch[0].csi_code) && starSolidIcon}
              {swatch[0].crust && checkIcon}
            </span>
          </div>
        </div>
      ));
    }
    return (
      <div className="stored-csi-message">
        <h3>You haven't stored any colors yet.</h3>
      </div>
    );
  };

  const ArrayGroup = () => {
    if (common) {
      return full
        .filter((item) => item[0].crust)
        .map((swatch, i) => (
          <div
            onClick={() => handleClick(swatch[0], "swatch")}
            key={swatch[0].csi_code + i}
            className="csi-swatch"
            style={{
              background: "#FEFEFE",
              fontSize: swatch[0].csi_name.length <= 12 ? "14px" : "13px",
            }}
          >
            <div
              className="csi-thumbnail"
              style={{
                backgroundColor: swatch[0].hex,
              }}
            />
            <div
              className="csi-text-background"
              style={{ background: swatch[0].hex + "40" }}
            >
              <h3>
                {swatch[0].csi_code} - {swatch[0].csi_name}
              </h3>
            </div>
            <div
              className="csi-thumbnail-right"
              style={{
                backgroundColor: swatch[0].hex,
              }}
            >
              <span style={{ color: swatch[0].isDark ? "white" : "#3E4042" }}>
                {store.includes(swatch[0].csi_code) && starSolidIcon}
                {swatch[0].crust && checkIcon}
              </span>
            </div>
          </div>
        ));
    }
    return full.map((swatch, i) => (
      <div
        onClick={() => handleClick(swatch[0], "swatch")}
        key={swatch[0].csi_code + i}
        className="csi-swatch"
        style={{
          background: "#FEFEFE",
          fontSize: swatch[0].csi_name.length <= 12 ? "14px" : "13px",
        }}
      >
        <div
          className="csi-thumbnail"
          style={{
            backgroundColor: swatch[0].hex,
          }}
        />
        <div
          className="csi-text-background"
          style={{ background: swatch[0].hex + "40" }}
        >
          <h3>
            {swatch[0].csi_code} - {swatch[0].csi_name}
          </h3>
        </div>
        <div
          className="csi-thumbnail-right"
          style={{
            backgroundColor: swatch[0].hex,
          }}
        >
          <span style={{ color: swatch[0].isDark ? "white" : "#3E4042" }}>
            {store.includes(swatch[0].csi_code) && starSolidIcon}
            {swatch[0].crust && checkIcon}
          </span>
        </div>
      </div>
    ));
  };

  return (
    <motion.div className="container" ref={containerRef}>
      <div className="swatch-array-page">
        <div className="csi-header">
          <div className="app-title" onClick={() => setViewStore(false)}>
            {utilityLogoMatlib}
          </div>
          <div className="search-box">
            {search === "" ? (
              <span className="search-icon">{searchIcon}</span>
            ) : (
              <span className="search-icon" onClick={() => setSearch("")}>
                {closeIcon}
              </span>
            )}
            <input
              className="input-box"
              type="text"
              value={search}
              placeholder="SEARCH CSI"
              onChange={handleSearch}
            />
          </div>

          {/* <h5>
              &#9658; Tracking {full.length === 0 ? csi.length : full.length} Colors
            </h5> */}
          <div className="nav-menu-button csi-count">
            <motion.div
              className="nav-menu-button-icon"
              whileHover={{
                scale: 1.1,
                color: "#FAFB00",
                transition: { duration: 0.2, delay: 0 },
              }}
              whileTap={{ scale: 0.99 }}
              onClick={() => setOpenNav(!openNav)}
            >
              {menuIcon}
            </motion.div>
          </div>
        </div>
        <div className="csi-array">
          {viewStore ? <SelectGroup /> : <ArrayGroup />}
          {search !== "" && full.length === 0 ? (
            <div className="stored-csi-message">
              <h3>"{search}" cannot be found!</h3>
            </div>
          ) : null}
        </div>
      </div>
      <NavMenu
        store={store}
        viewStore={viewStore}
        setViewStore={setViewStore}
        openNav={openNav}
        setOpenNav={setOpenNav}
        settingDialog={settingDialog}
        setSettingDialog={setSettingDialog}
        openImageDialog={openImageDialog}
        setOpenImageDialog={setOpenImageDialog}
        common={common}
        setCommon={setCommon}
      />
      <Menu
        store={store}
        viewStore={viewStore}
        setViewStore={setViewStore}
        settingDialog={settingDialog}
        setSettingDialog={setSettingDialog}
        width={width}
        height={height}
        openImageDialog={openImageDialog}
        setOpenImageDialog={setOpenImageDialog}
      />

      <DialogModal
        popup={popup}
        handleClose={handleClose}
        store={store}
        selected={selected}
        startDownload={startDownload}
        colorAttributeFound={colorAttributeFound || []}
        handleClick={handleClick}
        similarColorThumb={similarColorThumb}
        setSettingDialog={setSettingDialog}
        width={width}
        height={height}
        enableToolTip={enableToolTip}
        handleStore={handleStore}
      />
      <SettingsModal
        similarColorThumb={similarColorThumb}
        setSimilarColorThumb={setSimilarColorThumb}
        settingDialog={settingDialog}
        setSettingDialog={setSettingDialog}
        colorDelta={colorDelta}
        setColorDelta={setColorDelta}
        enableToolTip={enableToolTip}
        setEnableToolTip={setEnableToolTip}
      />

      <ImageDialog
        store={store}
        handleStore={handleStore}
        openImageDialog={openImageDialog}
        setOpenImageDialog={setOpenImageDialog}
        csi={csi}
      />
    </motion.div>
  );
}

export default CsiList;
